import styled from 'styled-components';

import * as Text from '../../styles/shared/typography';
import * as colors from '../../styles/shared/colors';
import { respondTo } from '../../styles/shared/breakpoints';
import { InformationDrawer } from './Drawer/styles';
import PageSection from '../PageSection';

const isiBodyFontSize = '17px';


export const SafetyPageContainer = styled(PageSection)`
  height: 100%;
  > section {
    margin-bottom: 60px;

    &:last-child {
      margin-bottom: 0;
    }

    ${Text.H3} {
      margin-bottom: 20px;
      text-transform: uppercase;
      
      ${respondTo.sm`
        margin-bottom: 30px;
      `}
    }
  }

`;

export const IsiBody = styled(Text.Body)`
  overflow: auto;
   height: 85%;
  margin-bottom: 24px;
  font-size: ${isiBodyFontSize};
  color: #000000;
  padding: 20px 20px 20px 0px;
  ${respondTo.sm`
    margin-bottom: 32px;
    gap: 32px;
  `}

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;

  ${InformationDrawer} & {
  padding: 20px;
    
    ${respondTo.sm`
      padding: 30px;`}
  }
`;


// Safety List

export const SafetyListContainer = styled.section`
  height: 100%;
  overflow: auto;

  ${InformationDrawer} & {
    margin: 0;
    padding: 20px;

    ${respondTo.sm`
      padding: 30px;`}
  }
`;

export const SafetyItem = styled.div`
  margin-bottom: 24px;
`;

export const SafetyItemTitle = styled(Text.H6)`
  font-size: ${isiBodyFontSize};
  margin-bottom: 10px;
  color: ${colors.primaryButtonBlue};
  font-weight:700;
`;
export const SafetySubItemTitle = styled(Text.H6)`
  font-size: ${isiBodyFontSize};
  margin-bottom: 8px;
  margin-top:16px;
  color: #000000;
  text-decoration: underline;
  font-weight:400;
`;

export const SafetyItemList = styled(Text.Ul)`
  li {
    font-size: ${isiBodyFontSize};
        color: #000000;
  }
  &:last-child {
    padding-bottom: 0;
  }
`;

export const SafetyWarningTitle = styled(SafetyItemTitle)`
  color: #000000;
  ${({flat}) => flat && 'margin-bottom: 1px;'}
`;

export const SafetyWarningList = styled(SafetyItemList)`
  li {
    font-size: ${isiBodyFontSize};
    font-weight: 700;
    ${({flat}) => flat && 'margin-bottom: 0px;'}
  }
`;

export const FinalWarning = styled(SafetyItemTitle)`
  margin: 0;
  line-height: calc(1em + 6px);

  a {
    color: ${colors.secondaryBrandRed};
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`;

export const SafetyJobCode = styled(Text.Footnote)`
  display: block;
  margin-top: 24px;
  text-align: right;
`;